import { LitElement, html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';

import componentStyles from './fil-tint.styles.js';

/**
 * @tag fil-tint
 * @property {'negative'|'neutral'|'positive'}[color] Color of the tint
 */
export class FilTint extends LitElement {
  static properties = {
    color: { type: String }, // 'negative' | 'neutral' | 'positive'
  };

  static styles = [componentStyles];

  constructor() {
    super();
    this.color = 'neutral';
  }

  render() {
    const classes = {
      [`fil-tint--${this.color}`]: this.color,
    };
    return html`<span class="fil-tint${classMap(classes)}"><slot></slot></span>`;
  }
}

export default FilTint;
